import React from 'react';
import ITService from '../images/it.svg';
import { Link } from 'react-router-dom';
import { FaCloud, FaLock, FaMobileAlt, FaDesktop } from 'react-icons/fa';
import SubserviceDetailComponent from '../components/SubserviceDetailComponent';

const services = [
  {
    icon: <FaCloud />,
    title: 'IT Roadmap Development',
    description: 'Plan your technology journey with a strategic IT roadmap. We outline clear goals and milestones to guide your IT initiatives and digital transformation.',
  },
  {
    icon: <FaLock />,
    title: 'Technology Assessment',
    description: 'Evaluate your current technology infrastructure with our comprehensive assessment. Identify strengths, weaknesses, and opportunities for improvement.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Digital Transformation',
    description: 'Embrace digital transformation with our consulting services. We help integrate advanced technologies to enhance business processes and drive innovation.',
  },
];

const ITStrategy = () => {
  return (
    <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={ITService}
        alt="IT Services"
      />

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">IT Strategy & Consulting</h1>
      </section>
     

      <section>
        <SubserviceDetailComponent services={services}/>
        <div className='mb-6'>
      <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert IT Services</h2>
      <p className="text-md text-black mb-6 px-12 text-left">
      Maximize efficiency, enhance security, and drive growth with our tailored IT Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic IT planning to meet your business needs.
      </p>
      
      <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
      </div>
      </section>

    </div>

    </div>
  )
}

export default ITStrategy
